import { computed, ref } from "vue";
import { defineStore } from "pinia";

const STORAGE_KEY = "timepoint_review_mode";

export const useReviewStore = defineStore("review", () => {
  const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
  const mode = ref(stored);
  const context = ref(null);
  const expired = ref(false);

  const enabled = computed(
    () => mode.value?.enabled === true && expired.value === false,
  );

  const setMode = (value) => {
    mode.value = value?.enabled ? value : null;
    expired.value = false;
    if (mode.value) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(mode.value));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  };

  const setContext = (value) => {
    context.value = value;
  };

  const markExpired = () => {
    expired.value = true;
  };

  const reset = () => {
    mode.value = null;
    context.value = null;
    expired.value = false;
    localStorage.removeItem(STORAGE_KEY);
  };

  return {
    mode,
    context,
    expired,
    enabled,
    setMode,
    setContext,
    markExpired,
    reset,
  };
});
